import React from "react";
import PropTypes from "prop-types";
import BreadcrumbBar from "widgets/BreadcrumbBar";

export default function Breadcrumb({ currentStep = 0, numSelected = 0 }){
	let stepNames = [
		"Select Serving Method",
		(numSelected ? `Select Versions (${numSelected})` : "Select Versions"),
	];

	return (
		<BreadcrumbBar
			stepNames = {stepNames}
			currentStep = {currentStep}
		/>
	);
}

Breadcrumb.displayName = "MultiVariantBreadcrumb";
Breadcrumb.propTypes = {
	currentStep: PropTypes.number,
	numSelected: PropTypes.number,
};
